<template>
  <div>
    <el-row class="panel-group" :gutter="40">
      <el-col
        v-for="item in panelData"
        :key="item.name"
        :xs="12"
        :sm="12"
        :md="6"
        class="card-panel-col"
      >
        <div>
          <div class="card-panel">
            <div class="card-panel-icon-wrapper icon-people">
              <i class="card-panel-icon" :class="item.icon" />
            </div>
            <div class="card-panel-description">
              <div class="card-panel-text">{{ item.name }}</div>
              $
              <count-to
                :start-val="0"
                :end-val="item.value"
                :duration="1000"
                class="card-panel-num"
              />
            </div>
          </div>
        </div>
      </el-col>
    </el-row>
  </div>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
import { getSalePanel } from '@/api/dashboard'
import selectCompany from '@/components/select/companiesGlobal.vue'
import CountTo from 'vue-count-to'
const methods = {
  async onSelectCompany() {}
}
export default {
  components: {
    CountTo,
    selectCompany
  },
  data() {
    return {
      saleData: {
        today: 0,
        total: 0,
        yesterday: 0,
        thisM: 0,
        lastM: 0
      }
    }
  },
  async created() {
    this.saleData = await getSalePanel({ company_id: this.company_id })
  },
  computed: {
    ...mapGetters('variable', ['company_id']),
    panelData() {
      const data = [
        {
          name: '今日銷售額',
          value: this.saleData.today,
          icon: 'el-icon-s-marketing'
        },
        {
          name: '昨日銷售額',
          value: this.saleData.yesterday,
          icon: 'el-icon-s-marketing'
        },

        {
          name: '本月銷售額',
          value: this.saleData.thisM,
          icon: 'el-icon-s-marketing'
        },
        {
          name: '上月銷售額',
          value: this.saleData.lastM,
          icon: 'el-icon-s-marketing'
        }
      ]
      return data
    }
  },

  methods,
  watch: {
    async company_id() {
      this.saleData = await getSalePanel({ company_id: this.company_id })
    }
  }
}
</script>
<style lang="scss" scoped>
.panel-group {
  margin-top: 18px;

  .card-panel-col {
    margin-bottom: 32px;
  }

  .card-panel {
    height: 108px;
    cursor: pointer;
    font-size: 12px;
    position: relative;
    overflow: hidden;
    color: #666;
    background: #fff;
    box-shadow: 4px 4px 40px rgba(0, 0, 0, 0.05);
    border-color: rgba(0, 0, 0, 0.05);

    &:hover {
      .card-panel-icon-wrapper {
        color: #fff;
      }

      .icon-people {
        background: #40c9c6;
      }

      .icon-message {
        background: #36a3f7;
      }

      .icon-money {
        background: #f4516c;
      }

      .icon-shopping {
        background: #ceae1e;
      }
    }

    .icon-people {
      color: #40c9c6;
    }

    .icon-message {
      color: #36a3f7;
    }

    .icon-money {
      color: #f4a851;
    }

    .icon-shopping {
      color: #bf4934;
    }

    .card-panel-icon-wrapper {
      float: left;
      margin: 14px 0 0 14px;
      padding: 16px;
      transition: all 0.38s ease-out;
      border-radius: 6px;
    }

    .card-panel-icon {
      float: left;
      font-size: 48px;
    }

    .card-panel-description {
      float: right;
      font-weight: bold;
      margin: 26px;
      margin-left: 0px;

      .card-panel-text {
        line-height: 18px;
        color: rgba(0, 0, 0, 0.45);
        font-size: 16px;
        margin-bottom: 12px;
      }

      .card-panel-num {
        font-size: 25px;
      }
    }
  }
}

@media (max-width: 550px) {
  .card-panel-description {
    display: none;
  }

  .card-panel-icon-wrapper {
    float: none !important;
    width: 100%;
    height: 100%;
    margin: 0 !important;

    .svg-icon {
      display: block;
      margin: 14px auto !important;
      float: none !important;
    }
  }
}
</style>
